<template>
  <div>
    <modal-provider
      name="warning-modal"
      :width="600"
      @before-open="beforeModalOpen"
      classList="warning-modal"
      :title="warningTitle"
    >
      <span class="warning-text">{{ warningText }}</span>
    </modal-provider>
  </div>
</template>

<script>
export default {
  name: 'WarningModal',
  data () {
    return {
      warningText: '',
      warningTitle: ''
    }
  },
  methods: {
    beforeModalOpen ({ params }) {
      this.warningText = params.text
      this.warningTitle = params.title
    }
  }
}
</script>
<style lang="sass" scoped>

::v-deep .modal-body
  padding-top: 0
.warning-text
  font-size: 16px
  line-height: 1.5
  +mmax(450)
    font-size: 14px
</style>
